__turbopack_context__.v({
  "container": "OnboardingLoader-module-scss-module__iGbXda__container",
  "loader": "OnboardingLoader-module-scss-module__iGbXda__loader",
  "message": "OnboardingLoader-module-scss-module__iGbXda__message",
  "overlay": "OnboardingLoader-module-scss-module__iGbXda__overlay",
  "spin": "OnboardingLoader-module-scss-module__iGbXda__spin",
  "spinner": "OnboardingLoader-module-scss-module__iGbXda__spinner",
});
